export class LocationsReducerState {
  locationIds?: any[];

  constructor(locationIds?: any[]) {
    this.locationIds = locationIds || [];
  }
}
